import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/FloatingContact.css";

const FloatingContact = () => {
  const phoneNumber = "919121943442"; // Your phone number for WhatsApp & Call
  const email = "indianodysseyofficial@gmail.com"; // Your email
  const whatsappMessage =
    "Hello, I'm interested in your travel services! Could you provide more details?";
  const emailSubject = "Inquiry about Travel Packages";
  const emailBody =
    "Hi, I would like to know more about your travel packages. Please provide details.";

  return (
    <div className="floating-buttons">
      <a
        className="floating-btn floating-btn-whatsapp"
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
          whatsappMessage
        )}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        title="Chat on WhatsApp"
      >
        <i className="bi bi-whatsapp" aria-hidden="true"></i>
      </a>

      <a
        className="floating-btn floating-btn-call"
        href={`tel:+${phoneNumber}`}
        aria-label="Call us"
        title="Call us"
      >
        <i className="bi bi-telephone-fill" aria-hidden="true"></i>
      </a>

      <a
        className="floating-btn floating-btn-mail"
        href={`mailto:${email}?subject=${encodeURIComponent(
          emailSubject
        )}&body=${encodeURIComponent(emailBody)}`}
        aria-label="Email us"
        title="Email us"
      >
        <i className="bi bi-envelope-fill" aria-hidden="true"></i>
      </a>
    </div>
  );
};

export default FloatingContact;
